import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-ice';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-232" data-mp="370ajwrjw8kg4">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-233" data-mp="31ybfrfgbxji4">
        <div className="text-center" data-id="element-234" data-mp="2x09z116dlw9t">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-235" data-mp="2x1bh3plt7j11">
            Coach to coach
          </p>
          <h2 className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-236" data-mp="v9gbnrq5car9">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-237" data-mp="qbeujcca6lif">
            Rated 4.9/5 by 1,200+ coaches across rec, Little League and travel
            ball.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-238" data-mp="m62o01dvk1s9">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-ice-dark bg-white p-5 shadow-card" data-id="element-239" data-mp="79bn1nojyi0j" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-240" data-mp="zwfv61ixzcgj">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-ice-dark" data-id="element-241" data-mp="14vj2xtqb3ws7" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-[11px] font-bold text-white" data-id="element-242" data-mp="1iv1yln1xlfnm">
                    {item.author.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase() || 'BP'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-243" data-mp="1sjpdv0n0tngy">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-244" data-mp="1jhg62ij50879" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-245" data-mp="14tbkn6sp9iks">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-246" data-mp="10sj9g809p3lv">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-247" data-mp="10px5sjghz88x">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}